import { TextInput, Textarea, Select } from "@mantine/core";
import { IconSettings, IconWallet } from "@tabler/icons-react";
import {
  ENUM_FORM_DISPLAY,
  ENUM_FORM_LAYOUT_CONTAINER,
} from "../../components/pageList";

import OrderList from "../../components/orderList";
import UserGroupMemberRow from "../../components/userGroupMemberRow";
import UserGroupWalletInfo from "../../components/userGroupWalletInfo";

const apiEntity = "userGroup";
const initialValues = {
  name: "",
  description: "",
  status: "ACTIVE",
  members: [],
};

export const UserGroupFormSchema = {
  title: "User Group",
  titleField: "name",
  display: {
    mode: ENUM_FORM_DISPLAY.LINK,
    size: "xl",
  },
  apiEntity,
  initialValues,
  showSaveBar: false,

  validate: {
    name: (value) =>
      !value || value.length < 2
        ? "Name must have at least 2 characters"
        : null,
  },

  layout: {
    containers: [
      {
        key: "main-tab",
        parent: null,
        type: ENUM_FORM_LAYOUT_CONTAINER.TABS,
        props: {
          variant: "default",
          defaultValue: "Members",
        },
        tab: [
          {
            key: "tab-members",
            label: "Members",
            icon: IconSettings,
          },
          {
            key: "tab-wallet",
            label: "Group Wallet",
            icon: IconWallet,
          },
        ],
      },
      {
        key: "section-basicInfo",
        parent: "tab-members",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Basic Info",
          description: "Please fill in the basic info of the user group",
          withBorder: false,
          mt: 0,
          mb: 20,
        },
      },
      {
        key: "section-members",
        parent: "tab-members",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Members",
          description:
            "Add group members (clients) and their commission share percentage",
          withBorder: false,
          mt: 0,
          mb: 20,
        },
      },
      {
        key: "section-wallet",
        parent: "tab-wallet",
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          mt: 0,
          mb: 20,
        },
      },
    ],

    fields: [
      {
        name: "name",
        component: TextInput,
        parent: "section-basicInfo",
        props: {
          required: true,
          placeholder: "Group Name",
          label: "Group Name",
        },
      },
      {
        name: "description",
        component: Textarea,
        parent: "section-basicInfo",
        props: {
          placeholder: "Description",
          label: "Description",
        },
      },
      {
        name: "status",
        component: Select,
        parent: "section-basicInfo",
        props: {
          label: "Status",
          data: [
            { value: "ACTIVE", label: "Active" },
            { value: "INACTIVE", label: "Inactive" },
          ],
        },
      },
      {
        name: "members",
        component: OrderList,
        parent: "section-members",
        props: {
          label: "Members",
          onEnterSave: false,
          addLabel: "Add Member",
          defaultRowValue: { client: null, sharePercent: 0 },
          row: {
            component: UserGroupMemberRow,
          },
        },
      },
      {
        name: "wallet",
        component: UserGroupWalletInfo,
        parent: "section-wallet",
        props: {},
      },
    ],
  },
};
